import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

/** Only for previously captured totals; new awards are entered within their phase. */
@Composable
internal fun TourLegacyAwardEditor(bundle: TourPlayBundle, busy: Boolean, onSplit: (String, List<Int>) -> Unit) {
    val legacy = bundle.awards.filter { it.phase == null }
    if (legacy.isEmpty()) return
    var selected by remember(bundle.revision) { mutableStateOf("") }
    var counts by remember(selected, bundle.revision) { mutableStateOf(List(3) { "0" }) }
    Div(attrs = { classes("card") }) {
        H2 { Text("Starší prémie k doplnění") }
        P { Text("Původní souhrn je nutné rozdělit do skutečně odehraných fází. Celkový počet zůstane zachovaný.") }
        if (!bundle.correctionMode) P { Text("Pro doplnění nejprve otevřete opravu výsledků.") }
        legacy.forEach { a ->
            val name = bundle.qualification.firstOrNull { it.entryId == a.entryId }?.playerName ?: "Hráč"
            P {
                Text("$name · ${a.label} · celkem ${a.quantity}× ")
                if (bundle.correctionMode) Button(attrs = { if (busy) disabled(); onClick { selected = a.id } }) { Text("Rozdělit prémii $name") }
            }
            if (selected == a.id && bundle.correctionMode) {
                val numbers = counts.map { it.toIntOrNull() }
                val valid = numbers.all { it != null && it in 0..999 } && numbers.filterNotNull().sum() == a.quantity
                Form(attrs = { classes("tour-form"); onSubmit { it.preventDefault(); if (!busy && valid) onSplit(a.id, numbers.filterNotNull()) } }) {
                    TOUR_PHASES.forEachIndexed { index, (phase, label) ->
                        val hasGame = bundle.rows(phase).any { it.entryId == a.entryId && (if (phase == "final") it.game3 != null else it.played > 0) }
                        TourField("Prémie $label: $name", counts[index], busy || !hasGame) { value -> counts = counts.mapIndexed { i, old -> if (i == index) value else old } }
                    }
                    P { Text("Součet po fázích musí být ${a.quantity}.") }
                    Button(attrs = { classes("primary"); type(ButtonType.Submit); if (busy || !valid) disabled() }) { Text("Uložit rozdělení prémií") }
                    Button(attrs = { type(ButtonType.Button); if (busy) disabled(); onClick { selected = "" } }) { Text("Zrušit rozdělení") }
                }
            }
        }
    }
}
